import { extend, override } from "flarum/extend";
import LogInModal from "flarum/forum/components/LogInModal";
import SettingsPage from "flarum/forum/components/SettingsPage";
import ChangeEmailModal from "./ChangeEmailModal";
import ChangePasswordModal from "./ChangePasswordModal";
import Button from 'flarum/common/components/Button';


app.initializers.add("lltq-reset-password", (app) => {
  // Replace login footer
  override(LogInModal.prototype, "footer", function () {
    return (
      <>
        {app.forum.attribute('forgotPasswordLink') !== ''
          ? (
            <p className="LogInModal-forgotPassword">
              <a href={app.forum.attribute("forgotPasswordLink")} target={"_blank"}>
                {app.translator.trans("core.forum.log_in.forgot_password_link")}
              </a>
            </p>)
          : null
        }
        {!!app.forum.attribute('allowSignUp') && (
          <p className="LogInModal-signUp">{app.translator.trans(
            'core.forum.log_in.sign_up_text', { a: <a onclick={this.signUp.bind(this)} /> })}</p>
        )}
      </>
    );
  });

  // Remove 'Password' button
  extend(SettingsPage.prototype, "accountItems", function (items) {
    // Replace button
    let changePasswordButton;

    if (app.forum.attribute("allowChangePassword") != true) {
      if (app.forum.attribute("changePasswordLink") != '') {
        changePasswordButton = (
          <a
            href={app.forum.attribute("changePasswordLink")}
            target={"_blank"}
            className="Button"
          >
            {app.translator.trans("core.forum.settings.change_password_button")}
          </a>
        );
      } else {
        items.remove("changePassword");
      }
    } else {
      changePasswordButton = (
        Button.component(
          {
            className: 'Button',
            onclick: () => {
              app.modal.show(ChangePasswordModal);
            },
          },
          app.translator.trans("core.forum.settings.change_password_button")
        )
      );
    }

    if (changePasswordButton) {
      items.replace("changePassword", changePasswordButton);
    }

    // Remove change mail button
    if (app.forum.attribute("allowChangeMail") == true) {
      // Replace email button & modal
      items.replace(
        "changeEmail",
        Button.component(
          {
            className: 'Button',
            onclick: () => {
              app.modal.show(ChangeEmailModal);
            },
          },
          app.translator.trans("core.forum.settings.change_email_button")
        )
      );
    } else {
      items.remove("changeEmail");
    }
  });
});
